import { render, staticRenderFns } from "./index-Reports.vue?vue&type=template&id=1a48b89e&scoped=true"
import script from "./index-Reports.vue?vue&type=script&lang=js"
export * from "./index-Reports.vue?vue&type=script&lang=js"
import style0 from "./index-Reports.vue?vue&type=style&index=0&id=1a48b89e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a48b89e",
  null
  
)

export default component.exports